import { blockQuote } from './blockquote.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import { callFormatApi } from 'owa-editor/lib/utils/callApi';

const blockquote: RibbonButton = {
    key: 'blockquote',
    title: () => loc(blockQuote),
    imageSrc: require('../svg/blockquote.svg'),
    onExecute: editorViewState =>
        callFormatApi(
            editorViewState,
            'toggleBlockQuote',
            [
                element => {
                    element.style.borderLeft = '3px solid';
                    element.style.borderColor = '#C8C8C8';
                    element.style.paddingLeft = '1ex';
                    element.style.marginLeft = '0.8ex';
                    element.style.color = '#666666';
                },
            ],
            [] /* pass empty array to avoid logging */
        ),
    buttonState: formatState =>
        formatState.isBlockQuote ? RibbonButtonState.Checked : RibbonButtonState.Normal,
};

export default blockquote;
